import React from 'react';
import Header from '../Controller/Header';
import VerifyForm from '../Controller/VerifyForm';
function Verify() {
    return (<>
        <Header />
        <VerifyForm />
    </>
    );
}

export default Verify;
